import { ZfFormField, ZfFormFieldAlert, ZfFormFieldLabel, ZfInput } from '@zafire/react';
import { useFormikContext } from 'formik';
import { PortfolioForm } from '../AddPortfolioDialog';
import { FieldInfoTooltip } from './FieldInfoTooltip';
import { FieldLoadingSpinner } from './FieldLoadingSpinner';
import { StringFieldName } from './portfolioFormFieldName';

type FormTextFieldProps = {
  name: StringFieldName;
  label: string;
  mandatory?: boolean;
  tooltip?: string;
  maxLength?: number;
  placeholder?: string;
  readonly?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
};

export const FormTextField = ({
  name,
  label,
  mandatory,
  tooltip,
  maxLength,
  placeholder,
  readonly = false,
  disabled = false,
  isLoading = false,
}: FormTextFieldProps) => {
  const { values, touched, errors, getFieldProps } = useFormikContext<PortfolioForm>();

  return (
    <ZfFormField style={{ flex: 1, minWidth: 0 }} disabled={disabled}>
      <ZfFormFieldLabel slot="label" htmlFor={name} text={label} mandatory={mandatory}>
        {tooltip && <FieldInfoTooltip fieldName={name} text={tooltip} />}
      </ZfFormFieldLabel>
      <ZfInput
        name={name}
        id={name}
        value={values[name]}
        readonly={readonly}
        disabled={disabled}
        maxLength={maxLength}
        placeholder={placeholder}
        error={!!errors[name] && !!touched[name]}
        onInputChange={getFieldProps(name).onChange}
      >
        {isLoading && <FieldLoadingSpinner />}
      </ZfInput>
      <ZfFormFieldAlert slot="alert" id={name} alerts={[errors[name]?.toString() ?? '']} />
    </ZfFormField>
  );
};
